export default [
  {
    text: '00:15:00',
    value: 0.25
  },
  {
    text: '00:30:00',
    value: 0.5
  },
  {
    text: '00:45:00',
    value: 0.75
  },
  {
    text: '01:00:00',
    value: 1
  },
  {
    text: '01:30:00',
    value: 1.5
  },
  {
    text: '02:00:00',
    value: 2
  },
  {
    text: '02:30:00',
    value: 2.5
  },
  {
    text: '03:00:00',
    value: 3
  }
]



// WEBPACK FOOTER //
// ./src/components/painel/agendamento/ScheduleModal/interval.js